import { Injectable } from '@angular/core';
import { Router, Route, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanLoad } from '@angular/router';
import { ConfigService } from '../config.service';
import { AuthService } from './auth.service';

@Injectable()
export class AuthenticatedGuard implements CanActivate, CanLoad {
    constructor(private _auth: AuthService, private router: Router) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.checkLogin();
    }

    public canLoad(route: Route): Promise<boolean> {
        return this.checkLogin();
    }

    checkLogin(): Promise<boolean> {
        return this._auth.isAuthenticated().then( user => {
            if (!user) {
                if (ConfigService.app.oauthExternal) {
                    this.router.navigate(['/loginExternal']);
                } else {
                    this.router.navigate(['/login']);
                }
            }
            return user;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/authenticated.guard.ts